import { ColorEnum } from '@/constants/color'
import {
    productCellHeight,
    productRowHeight,
} from '@/features/pos/components/ProductCatalog/parts/ProductList/constants'
import { ItemMode } from '@/features/pos/components/ProductCatalog/parts/ProductList/types'
import { FC } from 'react'
import { StyleProp, View, ViewStyle } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface ProductSkeletonProps {
    mode?: ItemMode
    style?: StyleProp<ViewStyle>
}

const ProductSkeleton: FC<ProductSkeletonProps> = ({ mode, style }) => {
    const { styles } = useStyles(stylesheet, { mode })

    return <View style={[styles.container, style]} />
}

const stylesheet = createStyleSheet({
    container: {
        backgroundColor: ColorEnum.Violet150,
        borderColor: ColorEnum.GRAY_300,
        borderRadius: 8,
        borderWidth: 1,
        variants: {
            mode: {
                cell: {
                    height: productCellHeight,
                },
                row: {
                    height: productRowHeight,
                },
            },
        },
    },
})

export default ProductSkeleton
